<template>
	<PopupRouterView :showLeftIcon="true" label="Approval History Input"  entityName="approvalhistory" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="approvalInstances" optionsLabel="approvalTag" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Instance" id="input-" size="sm" :model.sync="model.approvalInstanceId"  :selected="model.approvalInstance != null ? model.approvalInstance.approvalTag : ''" @input="getApprovalInstances" />
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approver Type" id="input-" size="sm" :model.sync="model.approverTypeId"  :selected="model.approverType != null ? model.approverType.name : ''" @input="getApproverTypes" />
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="input-" size="sm" :model.sync="model.approvalStructureId"  :selected="model.approvalStructure != null ? model.approvalStructure.name : ''" @input="getApprovalStructures" />
				<app-input-textbox id="fieldset-approver-level" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="input-approver-level" size="sm" :model.sync="model.approverLevel"   />
				<app-input-textbox id="fieldset-approver-user-name" label-cols-sm="4" label-cols-lg="3" label="Approver User Name" label-for="input-approver-user-name" size="sm" :model.sync="model.approverUserName"   />
				<app-input-textbox id="fieldset-sequence" label-cols-sm="4" label-cols-lg="3" label="Sequenc" label-for="input-sequence" size="sm" :model.sync="model.sequence"   />
				<app-input-combobox-autocomplete :options="activityStates" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Activity State" id="input-" size="sm" :model.sync="model.acitivtyStateId"  :selected="model.acitivtyState != null ? model.acitivtyState.name : ''" @input="getActivityStates" />
				<app-input-combobox-autocomplete :options="approvalConfigurationInstanceDetails" optionsLabel="approverType" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Instance Detail" id="input-" size="sm" :model.sync="model.approvalConfigurationInstanceDetailId"  :selected="model.approvalConfigurationInstanceDetail != null ? model.approvalConfigurationInstanceDetail.approverType : ''" @input="getApprovalConfigurationInstanceDetails" />
				<app-input-textbox id="fieldset-message" label-cols-sm="4" label-cols-lg="3" label="Message" label-for="input-message" size="sm" :model.sync="model.message"   />
				<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="input-status" size="sm" :model.sync="model.status"   />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalHistory from '@/models/ApprovalHistory/ApprovalHistory';
import ApprovalHistoryList from '@/models/ApprovalHistory/ApprovalHistoryList';
import ApprovalHistoryFilter from '@/filters/ApprovalHistory/ApprovalHistoryFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputComboboxAutocomplete,AppInputTextbox,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterApprovalHistory : null,
			currentApprovalHistoryPage : 1,
			approvalHistoryPageSize: 10,
			sortByApprovalHistory: '',
			sortDescApprovalHistory: '',
			approvalInstances: [],
			approverTypes: [],
			approvalStructures: [],
			activityStates: [],
			approvalConfigurationInstanceDetails: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalHistory : async function(id) {
			this.isBusy = true;
			ApprovalHistory.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalHistory = true;
			this.filterApprovalHistory.id = this.modelId;
			ApprovalHistory.downloadDataDetail(this, this.filterApprovalHistory).then(result => {
				this.isDownloadApprovalHistory = false;
			}).catch(error => { this.isDownloadApprovalHistory = false; })
		},
		getApprovalInstances : async function(input) {
			let filter = new ApprovalInstanceFilter();
			if (input != undefined) {
				filter.approvalTag = input;
			}
			ApprovalInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalHistory.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalhistoryindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalHistory.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalhistoryindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getApprovalHistorys();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterApprovalHistory = new ApprovalHistoryFilter();
		this.getApprovalInstances();
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getActivityStates();
		this.getApprovalConfigurationInstanceDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalHistory(id);
			} else {
				this.modelId = id;
				this.getApprovalHistory(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
